<div class="min-h-screen overflow-x-hidden bg-white font-sans text-[#171923]">
  <app-headerhome></app-headerhome>

  <section class="px-6 pb-3 pt-14 text-center">
    <h1 class="mb-2.5 font-display text-[32px] font-extrabold">{{ contactContent.title || "We'd love to hear from you" }}</h1>
    <p class="mx-auto max-w-[720px] text-[15.5px] text-muted">{{ contactContent.subtitle || 'Got a question or need help? Send us a message and our team will get right back to you.' }}</p>
  </section>

  <section class="px-6 pb-[90px] pt-10">
    <div class="mx-auto grid max-w-[1000px] grid-cols-1 items-start gap-8 md:grid-cols-[1.4fr_1fr]">
      <article class="rounded-[20px] border border-[#efeff2] bg-white p-6 shadow-[0_2px_8px_rgba(16,24,40,.05)] sm:p-8">
        @if (sent) {
          <div class="py-10 text-center" aria-live="polite">
            <div class="mx-auto mb-[18px] grid size-[60px] place-items-center rounded-full bg-[#e7f6ee] text-[#1e8e5a]">
              <svg class="size-[26px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>
            </div>
            <h2 class="mb-2 font-display text-[19px] font-extrabold">Message sent</h2>
            <p class="text-[14.5px] text-muted">Thanks for reaching out — we'll respond within one business day.</p>
            <button type="button" class="focus-ring mt-6 rounded-[10px] border border-[#e6e8ec] bg-white px-5 py-2.5 text-sm font-bold text-copy" (click)="sendAnother()">Send another message</button>
          </div>
        } @else {
          <form class="flex flex-col gap-4" [formGroup]="contactForm" (ngSubmit)="submit()" novalidate>
            <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
              <label>
                <span>Your name</span>
                <input type="text" formControlName="name" autocomplete="name" placeholder="Your name">
                @if (contactForm.get('name')?.touched && contactForm.get('name')?.invalid) {
                  <small>Enter your name.</small>
                }
              </label>
              <label>
                <span>Your email</span>
                <input type="email" formControlName="email" autocomplete="email" placeholder="you@email.com">
                @if (contactForm.get('email')?.touched && contactForm.get('email')?.invalid) {
                  <small>Enter a valid email address.</small>
                }
              </label>
            </div>

            <label>
              <span>Message</span>
              <textarea formControlName="message" rows="5" placeholder="How can we help?"></textarea>
              @if (contactForm.get('message')?.touched && contactForm.get('message')?.invalid) {
                <small>Tell us how we can help.</small>
              }
            </label>

            @if (submitted && contactForm.invalid) {
              <p class="form-summary-error text-[13px] font-semibold">Please fill in your name, a valid email and a message before sending.</p>
            }

            <button class="brand-submit focus-ring rounded-[10px] border-0 p-3.5 text-[15px] font-bold" type="submit">Send message</button>
          </form>
        }
      </article>

      <aside class="flex flex-col gap-4">
        <article class="contact-card">
          <span class="contact-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 22s8-7.5 8-13a8 8 0 1 0-16 0c0 5.5 8 13 8 13z"/><circle cx="12" cy="9" r="2.5"/></svg>
          </span>
          <div>
            <h2>{{ contactContent.officeLabel || 'Head office' }}</h2>
            <p>{{ config?.site?.address || '+254 730 889 000 / +254 733 623 260' }}</p>
          </div>
        </article>
        <article class="contact-card">
          <span class="contact-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
          </span>
          <div>
            <h2>Phone</h2>
            <a [href]="supportPhoneHref">{{ contactContent.primaryPhoneLabel || 'Main line' }} {{ supportNumber }}</a>
            @if (contactContent.secondaryPhone) {
              <p>{{ contactContent.secondaryPhoneLabel }} {{ contactContent.secondaryPhone }}</p>
            }
          </div>
        </article>
        <article class="contact-card">
          <span class="contact-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 4h16v16H4z"/><path d="m22 6-10 7L2 6"/></svg>
          </span>
          <div>
            <h2>Email</h2>
            <a [href]="'mailto:' + supportEmail">{{ supportEmail }}</a>
          </div>
        </article>
      </aside>
    </div>

    @if (frequentlyAskedQuestions.length) {
      <div class="mx-auto mt-16 max-w-[900px]" aria-labelledby="booking-faq-title">
        <div class="mb-8 text-center">
          <p class="text-sm font-bold uppercase tracking-[0.14em] text-brand">Booking help</p>
          <h2 id="booking-faq-title" class="mt-2 font-display text-2xl font-extrabold text-ink sm:text-[30px]">Frequently asked questions</h2>
          <p class="mx-auto mt-3 max-w-[650px] text-sm leading-6 text-slate-600 sm:text-base">Find quick answers or contact the Mash Poa support team for more help.</p>
        </div>
        <div class="space-y-3">
          @for (item of frequentlyAskedQuestions; track item.question) {
            <details class="group rounded-2xl border border-line-soft bg-white px-5 py-4 shadow-sm sm:px-6">
              <summary class="focus-ring flex cursor-pointer list-none items-center justify-between gap-4 font-bold text-ink">
                {{ item.question }}
                <svg class="size-5 shrink-0 text-brand transition group-open:rotate-180" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>
              </summary>
              <p class="mt-3 max-w-[760px] text-sm leading-7 text-slate-600">{{ item.answer }}</p>
            </details>
          }
        </div>
      </div>
    }
  </section>

</div>
